export type Price = {
  amount: number;
  currency: string;
};

const turkishNumberFormat = new Intl.NumberFormat("tr-TR");

export const formatMoney = (money: number) => turkishNumberFormat.format(money);

export function DisplayMoney({ value }: { value?: Price }) {
  return (
    <span className="no-wrap">
      {formatMoney(value?.amount || 0)} {value?.currency}
    </span>
  );
}
